import React from "react";
import { connect } from "react-redux";
import { FormSubmitFeedback, helpers } from "React_BrandLib";
import { depascalize } from "humps";
import * as selectors from "../selectors";
import * as apiMiddlewareHelpers from "../helpers";

class ErrorFeedback extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.errorRef = React.createRef();
		this.scrollToError = this.scrollToError.bind(this);
	}

	scrollToError() {
		const { hasError } = this.props;

		if (hasError) {
			const element = this.errorRef ? this.errorRef.current : null;
			if (element) {
				helpers.scrollingTo(element);
			}
		}
	}

	componentDidMount() {
		this.scrollToError();
	}

	componentDidUpdate() {
		this.scrollToError();
	}

	render() {
		const { hasError, title, message, type } = this.props;
		return (
			<React.Fragment>
				{hasError && (
					<FormSubmitFeedback
						type={type}
						title={title}
						message={message}
						errorRef={this.errorRef}
					/>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const errors = selectors.getErrors(state);
	// Should we receive resources?
	const resources = ownProps.resources;
	const error = errors && errors.length > 0 ? errors[0] : null;
	let title = null;
	let message = null;
	let hasError = false;
	let type = null;

	if (error && resources) {
		// Specific Resource example ErrorPaymentMethodUnavailableMessage
		hasError = !!error;
		title = apiMiddlewareHelpers.getDynamicResource(
			resources,
			"Title",
			error.typeDescription,
			error.codeDescription
		);
		message = apiMiddlewareHelpers.getDynamicResource(
			resources,
			"Message",
			error.typeDescription,
			error.codeDescription
		);

		type = depascalize(error.typeDescription, { separator: "-" });
	}

	return {
		hasError,
		title,
		type,
		message
	};
};

export default connect(mapStateToProps)(ErrorFeedback);
